import React from 'react';
import { Button, Tooltip } from 'antd';
import { VOICE_ACTIVE_COLOR } from './FooterVoice.constants';

const VoiceIconButton = ({
    label,
    icon,
    onClick,
    danger = false,
    primary = false,
    soft = false,
    isDarkMode,
    disableTooltip = false,
}) => {
    const button = (
        <Button
            aria-label={label}
            icon={icon}
            type={primary ? 'primary' : 'text'}
            onClick={onClick}
            style={{
                width: 32,
                height: 32,
                minWidth: 32,
                borderRadius: '50%',
                padding: 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: primary || soft || danger ? 'none' : `1px solid ${isDarkMode ? '#434343' : '#e5e7eb'}`,
                background: primary
                    ? VOICE_ACTIVE_COLOR
                    : soft
                        ? isDarkMode ? 'rgba(29, 161, 242, 0.16)' : 'rgba(29, 161, 242, 0.10)'
                        : danger ? 'transparent' : isDarkMode ? '#262626' : '#fff',
                color: danger ? '#ff4d4f' : (soft ? VOICE_ACTIVE_COLOR : undefined),
                boxShadow: primary ? '0 2px 8px rgba(29, 161, 242, 0.28)' : 'none',
                flexShrink: 0
            }}
        />
    );

    if (disableTooltip) return button;

    return <Tooltip title={label}>{button}</Tooltip>;
};

export default VoiceIconButton;
